import React, { useState } from 'react';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';
import HeaderComp from './HeaderComp';

const Header = ({ context }) => {
	
	const ctxMenu 	= () => context.menu;
	const menu 		= ctxMenu();
	
	if (menu.json === null) {
		context.getMenu(window.location.origin + '/wp-json/vestbuild/v1/menu');
	}
    
    if (menu.json) {
		return (
			<HeaderComp menu={menu}></HeaderComp>
		);
		
	} else {
		
		return null;
		
	}
}
export default WithConsumer(Header);